// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  color: white;
  fill: white;
}

ion-icon {
  margin: 16px 0;
  height: 36px;
  width: 100%;
}

p {
  line-height: 22px;
}

h1 {
  margin: 0;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0 4px;
}

ion-button {
  border-radius: 4px;
  border: 2px solid white;
  text-transform: none;
  font-weight: bold;
  font-family: AppFontBold, sans-serif;
  --padding: 13px;
  --box-shadow: none;
}
ion-button.button-positive {
  color: var(--ion-color-primary);
  --background: white;
}
ion-button.button-negative {
  margin-top: 4px;
  --background: #00000000;
}

ion-row {
  padding: 8px;
}
ion-row ion-col {
  padding: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/allow-gps-modal/allow-gps-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,WAAA;AACD;;AAEA;EACC,cAAA;EACA,YAAA;EACA,WAAA;AACD;;AAEA;EACC,iBAAA;AACD;;AAEA;EACC,SAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;AACD;;AAEA;EACC,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;AACD;AACC;EACC,+BAAA;EACA,mBAAA;AACF;AAEC;EACC,eAAA;EACA,uBAAA;AAAF;;AAIA;EACC,YAAA;AADD;AAGC;EACC,aAAA;AADF","sourcesContent":["* {\n\tcolor: white;\n\tfill: white;\n}\n\nion-icon {\n\tmargin: 16px 0;\n\theight: 36px;\n\twidth: 100%;\n}\n\np {\n\tline-height: 22px;\n}\n\nh1 {\n\tmargin: 0;\n\twidth: fit-content;\n\tpadding: 0 4px;\n}\n\nion-button {\n\tborder-radius: 4px;\n\tborder: 2px solid white;\n\ttext-transform: none;\n\tfont-weight: bold;\n\tfont-family: AppFontBold, sans-serif;\n\t--padding: 13px;\n\t--box-shadow: none;\n\n\t&.button-positive {\n\t\tcolor: var(--ion-color-primary);\n\t\t--background: white;\n\t}\n\n\t&.button-negative {\n\t\tmargin-top: 4px;\n\t\t--background: #00000000;\n\t}\n}\n\nion-row {\n\tpadding: 8px;\n\n\tion-col {\n\t\tpadding: 12px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
